import { ReactElement } from 'react'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { Checkbox } from '@ui/forms'
import { PlanOutputValues } from './utils'

interface Props {
  /** Label of the second label line: the cross section, or the assembly of slabs. */
  detailLabel: string
}

const FORMATS = [
  { key: 'pdf', label: 'PDF' },
  { key: 'dxf', label: 'DXF' },
] as const

const PlanOutputFields = ({ detailLabel }: Props): ReactElement => {
  const rows: { key: keyof PlanOutputValues; label: string }[] = [
    { key: 'showGeometry', label: 'Geometrie' },
    { key: 'showLabel', label: 'Positionsname' },
    { key: 'showDetail', label: detailLabel },
  ]

  return (
    <Stack spacing={1} data-cy="plan-output-fields">
      <Divider>Planausgabe (erfordert Export)</Divider>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr repeat(2, 48px)',
          alignItems: 'center',
          justifyItems: 'start',
        }}
      >
        <Box />
        {FORMATS.map(format => (
          <Typography key={format.key} sx={{ justifySelf: 'center' }}>
            {format.label}
          </Typography>
        ))}
        {rows.map(row => [
          <Typography key={row.key}>{row.label}</Typography>,
          ...FORMATS.map(format => (
            <Box key={`${format.key}-${row.key}`} sx={{ justifySelf: 'center' }}>
              <Checkbox
                name={`${format.key}.${row.key}`}
                size="small"
                data-cy={`plan-output-${format.key}-${row.key}`}
                sx={{ padding: 0 }}
              />
            </Box>
          )),
        ])}
      </Box>
    </Stack>
  )
}

export default PlanOutputFields
